<i-feather
    *ngIf="isFeatherIcon"
    class="p-icon"
    [name]="name"
    [class.disabled]="disabled"
    [pStyle]="{
        pseudo: {
            hover: { color: { color: hoverColor } },
            focus: { color: { color: focusColor } }
        },
        color: { color: disabled ? 'base-disabled' : color },
        component: {
            'width':        ['icon', 'size', size],
            'height':       ['icon', 'size', size],
            'stroke-width': ['icon', 'stroke', size],
        }
    }"
></i-feather>

<mat-icon
    *ngIf="isSvgIcon"
    class="p-icon"
    [svgIcon]="name"
    [class.disabled]="disabled"
    [pStyle]="{
        pseudo: {
            hover: { color: { color: hoverColor } },
            focus: { color: { color: focusColor } }
        },
        color: { color: disabled ? 'base-disabled' : color },
        component: {
            'width':        ['icon', 'size', size],
            'height':       ['icon', 'size', size],
            'stroke-width': ['icon', 'stroke', size],
        }
    }"
></mat-icon>
